import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { Link } from "react-router";

const FaqAccordion = (props) => {
    const accordionRefs = useRef([]);

    const faqData =  props.faqData; 
    useEffect(() => {
        const accordionBoxes = document.querySelectorAll('.accordion_box');

        accordionBoxes.forEach((accordionBox) => {
            const accBtns = accordionBox.querySelectorAll('.acc-btn');

            accBtns.forEach((accBtn, index) => {
                const accBody = accBtn.nextElementSibling;
                accordionRefs.current[index] = accBody;

                let isAnimating = false;

                const handleClick = () => {
                    if (isAnimating) return;
                    isAnimating = true;

                    const target = accBtn.closest('.accordion');
                    const outerBox = accBtn.closest('.accordion_box');

                    if (accBtn.classList.contains('active')) {
                        gsap.to(accBody, {
                            duration: 0.3,
                            height: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            onComplete: () => {
                                accBody.style.display = 'none';
                                accBtn.classList.remove('active');
                                target.classList.remove('active-block');
                                isAnimating = false;
                            },
                        });
                    } else {
                        outerBox.querySelectorAll('.acc-btn').forEach((btn, otherIndex) => {
                            if (btn.classList.contains('active')) {
                                gsap.to(accordionRefs.current[otherIndex], {
                                    duration: 0.3,
                                    height: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    onComplete: () => {
                                        accordionRefs.current[otherIndex].style.display = 'none';
                                        btn.classList.remove('active');
                                        btn.closest('.accordion').classList.remove('active-block');
                                    },
                                });
                            }
                        });

                        accBody.style.display = 'block';
                        gsap.fromTo(
                            accBody,
                            { height: 0, paddingTop: 0, paddingBottom: 0 },
                            {
                                duration: 0.3,
                                height: 'auto',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                onComplete: () => {
                                    accBtn.classList.add('active');
                                    target.classList.add('active-block');
                                    isAnimating = false;
                                },
                            }
                        );
                    }
                };

                accBtn.addEventListener('click', handleClick);

                return () => {
                    accBtn.removeEventListener('click', handleClick);
                };
            });
        });
    }, []);

    return (
        <section className="faq pt-130 pb-130">
        <div className="container">
          <div className="row align-items-end mb-10">
            <div className="col-lg-8">
              <div className="section-title mb-30">
                <h3 className="title">
                  The answers you seek. Are within our{" "}
                  <span>frequently asked questions.</span>
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="faq-btn ul_li_right mb-30">
                <Link to="/contact" className="btn-link ul_li_right">
                  Let’s talk!{" "}
                  <span>
                    <img src="assets/img/icon/arrow-right2.svg" alt="" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        <div className="xb-faq">
            <ul className="accordion_box clearfix">
                {[...Array(faqData.length)].map((_, index) => (
                    <li className={`accordion block ${index === 0 ? 'active active-block' : ''}`} key={index}>
                        <span className="number">{String(index + 1).padStart(2, '0')}</span>
                        <div className={`acc-btn ${index === 0 ? 'active' : ''}`}>
                            {faqData[index].question}
                            <span className="arrow"></span>
                        </div>
                        <div className={`acc_body ${index === 0 ? 'current' : ''}`} style={{ display: index === 0 ? 'block' : 'none' }}>
                            <div className="content">
                                <p>{faqData[index].answer}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
        </div>
        </section>
    );
};




export default FaqAccordion;
